import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CareerYagiofferResetDialog',
  props: {
    value: { type: Boolean },
    name: null,
    title: null,
    message: null,
    actionsClass: null
  },
  emits: ['input', 'confirm'],
  setup(__props: any, { emit }) {





function onConfirm() {
  emit('input', false)
  emit('confirm')
}

return { __sfc: true,emit, onConfirm }
}

})